import type { MatchRule } from './matchRule';

// The original CountStrike task: destroy an enemy by selecting its own number.
export const identityRule: MatchRule = {
  id: 'identity',
  label: 'Number Match',
  instructions: 'Match each number with the same number to destroy it.',
  answerFor: (value) => value,
  displayFor: (value) => String(value),
  matches: (input, value) => input === value,
};
